export const PROPOSED_FILE = { merchant: 'shop.example', statementNames: ['SHPEX*'] };

export const STATEMENT = [
  { id: 'c1', date: '2026-06-03', name: 'SHPEX*8841 ONLINE', amount: '64.00' },
  { id: 'c2', date: '2026-06-04', name: 'CORNER GROCERY 112', amount: '23.17', familiar: true },
  { id: 'c3', date: '2026-06-05', name: 'TPX*DIGITAL 0391', amount: '119.99' },
];

export const AGENT_ORDERS = [
  { orderRef: 'ORD-20001', merchant: 'shop.example', agentId: 'agent.example/assistant', item: 'Neck cooling fan, size M', amount: '64.00', date: '2026-06-02', policy: 'Returns within 30 days. Prepaid return label. Refund to the original payment method.', policyShown: { agent: '2026-06-02 14:07 UTC', principal: null } },
  { orderRef: 'ORD-20002', merchant: 'shop.example', agentId: 'agent.example/assistant', item: 'Travel mug, blue', amount: '18.50', date: '2026-05-21', policy: 'Returns within 14 days, unused items only.', policyShown: { agent: '2026-05-21 09:42 UTC', principal: null } },
];

const days = (a, b) => Math.abs(new Date(a) - new Date(b)) / 86400000;

export function matchCharge(charge) {
  const store = PROPOSED_FILE.statementNames.some((p) => charge.name.startsWith(p)) ? PROPOSED_FILE.merchant : null;
  const order = AGENT_ORDERS.find((o) => o.merchant === store && o.amount === charge.amount && days(o.date, charge.date) <= 3) || null;
  return {
    checks: [
      { ok: !!store, label: store ? `Statement name matches a name listed by ${store}` : 'No store your agent bought from lists this statement name' },
      { ok: !!order, label: order ? `Amount ${charge.amount} matches ${order.orderRef}` : 'No order your agent placed has this amount and date' },
      { ok: !!order, label: order ? `Charged ${charge.date}, ordered ${order.date} (within 3 days)` : 'Nothing to compare the date against' },
    ],
    order,
  };
}
